import React, { useState } from "react";
import { Link } from "react-router";

import classNames from "classnames";

interface OptionProps {
  text?: string;
  value: string;
}

interface Props {
  dropdownOptions: ReadonlyArray<OptionProps>;
  onDropdownSelection: (option: OptionProps) => void;
}

const Dropdown: React.FC<Props> = ({ dropdownOptions, onDropdownSelection }: Props): JSX.Element => {
  const { text: defaultText = "" } = dropdownOptions[0] || {};
  const [dropdownSelectedText, setDropdownSelectedText] = useState(defaultText);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState<number>();

  const handleOnBlur = (): void => {
    const id = setTimeout(() => {
      if (dropdownVisible) {
        setDropdownVisible(false);
      }
    }, 0) as unknown as number;
    setTimeoutId(id);
  };

  const handleOnFocus = (): void => {
    clearTimeout(timeoutId);
    if (!dropdownVisible) {
      setDropdownVisible(true);
    }
  };

  const handleOnMouseDown = (): void => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleDropdownSelection = ({ text, value }: OptionProps): void => {
    setDropdownSelectedText(text || value);
    setDropdownVisible(false);
    onDropdownSelection({ text, value });
  };

  const showDateDropdownClass = classNames(
    "dropdown",
    {
      "dropdown-show": dropdownVisible,
      "opened": dropdownVisible,
    },
    "items");

  const dateDropdownIconClasses = classNames(
    "dropdown-header-icon",
    { "caprx-icon-inputarrowcaretdown": !dropdownVisible },
    { "caprx-icon-inputarrowcaretup": dropdownVisible },
  );

  const dropdownOptionEntries = dropdownOptions.map(({ text, value }) => {
    const selectedItemClass = classNames(
      "dropdown-link",
      {
        "selected-dropdown-item": dropdownSelectedText === text,
        focused: dropdownSelectedText === text,
      },
      "content",
    );

    return (
      <li key={value} className="dropdown-entry option">
        <Link className={selectedItemClass} onClick={(): void => handleDropdownSelection({ text, value })} to="#" replace>
          {text}
        </Link>
      </li>
    );
  });

  return (
    <div className="dropdown-wrapper">
      <div className="dropdown-header" onBlur={handleOnBlur} onFocus={handleOnFocus} onMouseDown={handleOnMouseDown} tabIndex={0}>
        {dropdownSelectedText}
        <span className={dateDropdownIconClasses} />
      </div>
      <ul className={showDateDropdownClass} onBlur={handleOnBlur} onFocus={handleOnFocus}>
        {dropdownOptionEntries}
      </ul>
    </div>
  );
};

export default Dropdown;
